/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TasksTaskCommentPermissions } from './tasksTaskCommentPermissions';
import { TasksTaskSubjectPermissions } from './tasksTaskSubjectPermissions';
import { TasksTaskPermissions } from './tasksTaskPermissions';
import { TasksTaskCommentLastSeenPermissions } from './tasksTaskCommentLastSeenPermissions';


import {ValidatorFn, Validators} from "@angular/forms";

export interface TasksPermissions { 
    task: TasksTaskPermissions;
    taskComment: TasksTaskCommentPermissions;
    taskCommentLastSeen: TasksTaskCommentLastSeenPermissions;
    taskSubject: TasksTaskSubjectPermissions;
}
export const TasksPermissions_task_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TasksPermissions_taskComment_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TasksPermissions_taskCommentLastSeen_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TasksPermissions_taskSubject_Validators: ValidatorFn[] =
    [  Validators.required, ];


